"use strict";
/**
 * index.js
 */
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var random = __importStar(require("./random"));
exports.getRandomBytes = random.getRandomBytes;
exports.getRandomAsciiString = random.getRandomAsciiString;
exports.getRandomString = random.getRandomString;
exports.getRandomSampledString = random.getRandomSampledString;
exports.default = { getRandomBytes: exports.getRandomBytes, getRandomAsciiString: exports.getRandomAsciiString, getRandomString: exports.getRandomString, getRandomSampledString: exports.getRandomSampledString };
//# sourceMappingURL=index.js.map